import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { getHistorialPorLeccion } from "../../../services/Api/HistorialUma";
import { getRolLabel } from "../../../utils/rolesUtils";
import {
  formatFechaHora,
  getAccionLabel,
  getDetalleMovimiento,
  getEtiquetaDetalle,
  getNombreUsuario,
  getPosicionMovimiento,
  ordenarPorFechaDesc,
} from "../historialLeccionesUtils";
import alertConfiguration from "../../../utils/alertsUtils";
import NoDataMessage from "../../../fragments/NoDataMessage";
import ReactLoading from "react-loading";

const movimientosPorPagina = 50;

const ModalHistorialLeccion = ({ leccion }) => {
  const [movimientos, setMovimientos] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [isLoadingMas, setIsLoadingMas] = useState(false);
  const [hayMas, setHayMas] = useState(false);

  useEffect(() => {
    obtenerMovimientos(0);
  }, []);

  const obtenerMovimientos = async (skip) => {
    try {
      if (skip === 0) setIsLoading(true);
      else setIsLoadingMas(true);

      const respuesta = await getHistorialPorLeccion(
        leccion?.uma?._id,
        skip,
        movimientosPorPagina
      );
      const pagina = ordenarPorFechaDesc(respuesta, (m) => m?.fechaCreacion);

      setMovimientos((previos) =>
        skip === 0 ? pagina : [...previos, ...pagina]
      );
      setHayMas(pagina.length === movimientosPorPagina);
    } catch (error) {
      console.error(error);
      toast.error(
        "Ocurrió un error al obtener el historial de la lección.",
        alertConfiguration
      );
    } finally {
      setIsLoading(false);
      setIsLoadingMas(false);
    }
  };

  if (isLoading) {
    return (
      <div className="flex justify-center py-10">
        <ReactLoading type="spin" color="#1A3D82" height={40} width={40} />
      </div>
    );
  }

  if (movimientos.length === 0) {
    return (
      <NoDataMessage
        message={"Esta lección no tiene movimientos registrados."}
        stylesWrapper="!my-10"
      />
    );
  }

  return (
    <div className="flex flex-col gap-3">
      <ol className="flex flex-col gap-3">
        {movimientos.map((movimiento) => {
          const detalle = getDetalleMovimiento(movimiento);
          const posicion = getPosicionMovimiento(movimiento);

          return (
            <li
              key={movimiento?._id}
              className="border border-gray-200 rounded-lg p-3 border-l-4 border-l-nimbusDark"
            >
              <div className="flex flex-wrap items-baseline justify-between gap-x-3">
                <p className="font-semibold text-nimbusDark">
                  {getAccionLabel(movimiento?.accion)}
                </p>
                <p className="text-xs text-gray-500">
                  {formatFechaHora(movimiento?.fechaCreacion)}
                </p>
              </div>

              {(detalle !== "" || posicion !== "") && (
                <p className="text-sm text-gray-700 mt-1">
                  <span className="font-semibold">
                    {getEtiquetaDetalle(movimiento)}:{" "}
                  </span>
                  {[detalle, posicion].filter((parte) => parte !== "").join(" · ")}
                </p>
              )}

              <p className="text-xs text-gray-500 mt-1">
                {getNombreUsuario(movimiento?.usuario)}
                {movimiento?.rolUsuario
                  ? ` · ${getRolLabel(movimiento.rolUsuario) ?? movimiento.rolUsuario}`
                  : ""}
              </p>
            </li>
          );
        })}
      </ol>

      {hayMas && (
        <button
          type="button"
          className="self-center px-5 py-2 rounded-lg font-semibold text-nimbusDark bg-gray-200 hover:bg-gray-300 transition-colors disabled:opacity-50"
          onClick={() => obtenerMovimientos(movimientos.length)}
          disabled={isLoadingMas}
        >
          {isLoadingMas ? "Cargando..." : "Cargar más"}
        </button>
      )}
    </div>
  );
};

export default ModalHistorialLeccion;
